module.exports = __webpack_public_path__ + "img/648.53ecc03c.png";